export function match(param: string) {
	return param !== "account" && param !== "experimental";
}
